import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, Container, CardHeader, CardFooter } from 'reactstrap';
import IButtonComponent from '../iComponents/iButton/IButton';
import { DownloadFileFromLink, DownloadFilesInZIPFromlinks, getIconByExtension, isDisabledPreview, PreviewFileFromLink } from '../../../helpers/attachments_helper';
import { useDispatch, useSelector } from 'react-redux';
import '../ShowAttachments/ShowAttachments.scss';
import Iloading from '../iComponents/iLoading/Iloading';
import { deleteDocumentInnoboDocs, getDocumentsInnoboDocs, uploadDocumentInnoboDocs } from '../../../store/documents/actions';
import Swal from 'sweetalert2';

const ShowInnoboDocuments = ({ GUID, type, Number }: any) => {
    const fileInput = useRef<HTMLInputElement | null>(null);
    const excludedFiles = ['exe','jar',''];
    const { documentListInnoboDocs, isLoading, isLoadingBase64,success } = useSelector((state: any) => state.Documents);
    const dispatch = useDispatch();
    const [documents, setDocuments] = useState<any>([]);
    const [selectedDocument, setSelectedDocument] = useState<any>('');
    const [searchTerm, setSearchTerm] = useState<string>('');

    useEffect(() => {
        dispatch(getDocumentsInnoboDocs({ GUID, type, Number }));
    }, [success]);
    useEffect(() => {
        setDocuments(documentListInnoboDocs);
    }, [documentListInnoboDocs]);


    const handleUploadClick = () => {
        if (fileInput.current) {
            fileInput.current.click();
        }
    };

    const DeleteDocuments = () => {
        const namesDocuments:any = [];
        const LinksDocuments:any = [];
        documents.map((item:any)=>{
            if(item.isSelected){
                namesDocuments.push(item.Name)
                LinksDocuments.push(item.urlLink)
            }else
            return;
        })


        Swal.fire({
            text: `You want to delete the documents: ${namesDocuments.join(",")}`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
              confirmButton: 'custom-confirm-button',
              cancelButton: 'custom-cancel-button'
            },
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteDocumentInnoboDocs(LinksDocuments))
            }
          });
    };

    const handleFileChange = (file: any) => {
        if (documents.length >= 15) {
            Swal.fire('Error', 'Maximum 15 documents', 'error');
            return;
        }
        const sizeInMB = file.size / (1024 * 1024);
        const fileParts = file.name.split('.');
        const extension = fileParts.length > 1 ? fileParts.pop()?.toLowerCase() : null;
    
        if (!extension) {
            Swal.fire('Error', 'The file has no valid extension and cannot be uploaded.', 'error');
            return;
        }
        if (sizeInMB <= 10 && !excludedFiles.includes(extension)) {
            dispatch(uploadDocumentInnoboDocs({ file, GUID, type, Number }));
        } else {
            Swal.fire('Error', 'Invalid file type or size exceeds 10MB.', 'error');
        }
    };

    const handleSelectDoc = (doc: any) => {
        setSelectedDocument(doc);
    };


    //-----------------------------------------------------
    const handleDownload = () => {
        if (selectedDocument) DownloadFileFromLink(selectedDocument.urlLink)
    }

    const handlePreview = () => {
        if (selectedDocument) PreviewFileFromLink(selectedDocument.urlLink,selectedDocument.Extension);
    };
    const handleDownloadZIP = async () => {
        const checkDocs = documents.filter((doc: any) => doc.isSelected);

        if (checkDocs.length > 0) {
            await DownloadFilesInZIPFromlinks(checkDocs, type, Number, 'my_documents');
        }
    };

    const validIdenticator = (identifier: any) => {
        return identifier === selectedDocument.Identifier;
    };
    const isDisabledButtonZIP = () => {
        const checkDocs = documents.filter((doc: any) => doc.isSelected);
        return checkDocs.length === 0;
    };
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, Identifier: string) => {
        const isChecked = event.target.checked;
        const updatedDocs = documents.map((doc: any) => {
            if (doc.Identifier === Identifier) {
                return { ...doc, isSelected: isChecked };
            }
            return doc;
        });
        setDocuments(updatedDocs);
    };

    const LoadingIndicator = () => {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    };
    const filteredDocs = documents.filter((doc: any) => doc.Name.toLowerCase().includes(searchTerm.toLowerCase()));
    return (
        <Container>
            <div className="container-sm">
                <Iloading loading={isLoadingBase64} />
            </div>
            <Card className={'container-ShowAttachments'}>
                <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>
                        My Files - {type} - {Number}
                    </h2>
                    <div className="search__container">
                        <input type="text" placeholder="Search..." value={searchTerm} onChange={handleSearchChange} className="search-input" />
                    </div>
                </CardHeader>
                <CardBody  style={{ overflowY: 'auto' }}>
                    <div className="container-sm">
                        <>{isLoading ? LoadingIndicator() : null}</>
                    </div>
                    <div className={'container-attachments'}>
                        {filteredDocs.map((doc: any) => (
                            <div
                                key={doc.Identifier}
                                className={`attachment-item ${validIdenticator(doc.Identifier) && 'selected-attachment'}`}
                                onClick={() => handleSelectDoc(doc)}
                            >
                                <i className={getIconByExtension(doc.Extension)}></i>
                                <span>
                                    {doc.Name}
                                </span>
                                <div className="custom-checkbox">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`formCheck-${doc.Identifier}`}
                                        aria-checked={doc.isSelected}
                                        onChange={(event: any) => handleCheckboxChange(event, doc.Identifier)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </CardBody>
                <CardFooter className="container_buttons_attachments mt-4">
                    {documents.length > 0 && (
                        <>
                        <IButtonComponent
                            className="btn-search text-nowrap w-auto"
                            actionOnClick={() => handleDownloadZIP()}
                            label={`Download Checked`}
                            btnIcon="dripicons-folder-open"
                            disabled={isDisabledButtonZIP()}
                        ></IButtonComponent>

                        <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => DeleteDocuments()}
                                label={`Delete`}
                                btnIcon="dripicons-trash"
                                disabled={isDisabledButtonZIP()}
                            ></IButtonComponent>
                        </>
                        
                    )}
                        <div className="d-flex" style={{ marginLeft: 'auto' }}>
                            {!isLoading && (
                                <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handleUploadClick()}
                                label={`Upload`}
                                btnIcon="dripicons-cloud-upload"
                            ></IButtonComponent>
                            )}
                            {selectedDocument && <>
                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handleDownload()}
                                label={`Download`}
                                btnIcon="dripicons-download"
                            ></IButtonComponent>

                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handlePreview()}
                                label={`Preview`}
                                btnIcon="dripicons-preview"
                                disabled={isDisabledPreview(selectedDocument.Extension)}
                            ></IButtonComponent>
                            
                            </>}
                        </div>

                </CardFooter>
                <input
                    type="file"
                    // accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(e:any)=>{handleFileChange(e.target.files[0])}}
                    ref={fileInput}
                />
            </Card>
        </Container>
    );
}

export default ShowInnoboDocuments